require('./bootstrap');
window.Vue = require('vue');
import Vue from 'vue';
Vue.config.devtools = false
import VueChatScroll from 'vue-chat-scroll';
import VueCountryCode from "vue-country-code";
import swal from 'sweetalert';
import AOS from 'aos';
import 'aos/dist/aos.css';
import 'boxicons';
import 'boxicons/css/boxicons.min.css';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import InfiniteLoading from 'vue-infinite-loading';

const localeSite = window.localeSite;
Vue.prototype.authuser = window.authuser;
Vue.use(VueCountryCode);
Vue.use(VueChatScroll);



Vue.component('register-component', () =>
    import ('./components/RegisterComponent.vue'));
Vue.component('category-component', () =>
    import ('./components/CategoryComponent.vue'));
Vue.component('search-component', () =>
    import ('./components/SearchComponent.vue'));
Vue.component('scrolltop-component', () =>
    import ('./components/scroll/scrollTopComponent.vue'));
Vue.component('scrolltop-arrow-component', () =>
    import ('./components/scroll/scrollTopArrowComponent.vue'));
Vue.component('apexchart', () =>
    import ('vue-apexcharts'));
//**********************************************************AdminComponent*******************************************
Vue.component('admin-add-blog-component', () =>
    import ('./components/admin/blog/addPostComponent.vue'));
Vue.component('admin-add-blog-expo', () =>
    import ('./components/admin/blog/addPostExpo.vue'));
Vue.component('unit-component', () =>
    import ('./components/admin/UnitComponent.vue'));
Vue.component('admin-edit-category-component', () =>
    import ('./components/admin/CategoryEditAdminComponent.vue'));
Vue.component('admin-show-currency-component', () =>
    import ('./components/admin/showCurrencyAdminComponent.vue'));
Vue.component('admin-activities-component', () =>
    import ('./components/admin/activitiesAdminComponent.vue'));
Vue.component('admin-add-admin-component', () =>
    import ('./components/admin/AddAdminUserComponent.vue'));
Vue.component('admin-add-user-admin-component', () =>
    import ('./components/admin/AddUserComponent.vue'));
Vue.component('admin-add-product-component', () =>
    import ('./components/admin/addProductComponent.vue'));
Vue.component('admin-show-product-component', () =>
    import ('./components/admin/ShowProductComponent.vue'));
Vue.component('admin-en-translate-component', () =>
    import ('./components/admin/enTranslateComponent.vue'));
Vue.component('admin-ar-translate-component', () =>
    import ('./components/admin/arTranslateComponent.vue'));
Vue.component('banner-component', () =>
    import ('./components/admin/bannerComponent.vue'));
Vue.component('show-banner-component', () =>
    import ('./components/admin/showBannerComponent.vue'));
Vue.component('add-exhibition-component', () =>
    import ('./components/admin/addexhibitionComponent.vue'));
Vue.component('edit-exhibition-component', () =>
    import ('./components/admin/editexhibition.vue'));
Vue.component('show-exhibition-component', () =>
    import ('./components/admin/showExhibitionComponent.vue'));
Vue.component('show-tickets-component', () =>
    import ('./components/admin/showTicketsComponent.vue'));
Vue.component('dashboard-component', () =>
    import ('./components/admin/DashboardComponent.vue'));
Vue.component('special-product-component', () =>
    import ('./components/admin/specialProductComponent.vue'));
Vue.component('admin-inquery-component', () =>
    import ('./components/admin/inqueriesComponent.vue'));
Vue.component('admin-message-component', () =>
    import ('./components/admin/messagesComponent.vue'));
Vue.component('user-site-component', () =>
    import ('./components/admin/showUserSiteComponent.vue'));
Vue.component('admin-special-category', () =>
    import ('./components/admin/adminSpecialCategory.vue'));
Vue.component('admin-edit-special-cat', () =>
    import ('./components/admin/adminEditSpecialCategory.vue'));
Vue.component('send-email-all', () =>
    import ('./components/admin/sendEmailAll.vue'));
//**********************************************************VipComponent*******************************************

Vue.component('vip-upload-result', () =>
    import ('./components/vip/upload_result.vue'));
Vue.component('vip-setting', () =>
    import ('./components/vip/setting.vue'));
Vue.component('vip-index', () =>
    import ('./components/vip/index.vue'));
//email
Vue.component('vip-email-contacts', () =>
    import ('./components/vip/email/contacts.vue'));
Vue.component('vip-email-send-result', () =>
    import ('./components/vip/email/send_result.vue'));
Vue.component('vip-email-groups', () =>
    import ('./components/vip/email/groups.vue'));
Vue.component('vip-email-groups-detail', () =>
    import ('./components/vip/email/detail.vue'));
Vue.component('vip-email-send-email', () =>
    import ('./components/vip/email/send_email.vue'));
//sms
Vue.component('vip-sms-groups', () =>
    import ('./components/vip/sms/groups.vue'));
Vue.component('vip-sms-contacts', () =>
    import ('./components/vip/sms/contacts.vue'));
Vue.component('vip-sms-send-result', () =>
    import ('./components/vip/sms/send_result.vue'));
Vue.component('vip-sms-groups-detail', () =>
    import ('./components/vip/sms/detail.vue'));
Vue.component('vip-send-sms', () =>
    import ('./components/vip/sms/send_sms.vue'));


//**********************************************************Admin-vipComponent*******************************************
//Discount
Vue.component('add-discount', () =>
    import ('./components/admin/Vip/discounts/add_discount.vue'));
Vue.component('show-discount', () =>
    import ('./components/admin/Vip/discounts/show_discount.vue'));
Vue.component('edit-discount', () =>
    import ('./components/admin/Vip/discounts/edit_discount.vue'));
Vue.component('show-use-discount', () =>
    import ('./components/admin/Vip/use/show.vue'));
Vue.component('show-use-edu-discount', () =>
    import ('./components/admin/Vip/use/show_edu.vue'));
//Subscript 
Vue.component('edit-subscript', () =>
    import ('./components/admin/Vip/subscript/edit_subscript.vue'));
Vue.component('show-subscript', () =>
    import ('./components/admin/Vip/subscript/show_subscript.vue'));
//log
Vue.component('wallet-log', () =>
    import ('./components/admin/Vip/log/wallet.vue'));
Vue.component('subscript-log', () =>
    import ('./components/admin/Vip/log/subscript.vue'));
Vue.component('exp-log', () =>
    import ('./components/admin/Vip/log/exp_date.vue'));
//Country
Vue.component('add-admin-country', () =>
    import ('./components/admin/Vip/country/add.vue'));
Vue.component('show-admin-countries', () =>
    import ('./components/admin/Vip/country/show.vue'));
Vue.component('edit-admin-country', () =>
    import ('./components/admin/Vip/country/edit.vue'));
//Groups
Vue.component('add-admin-groups', () =>
    import ('./components/admin/Vip/groups/add.vue'));
Vue.component('show-admin-groups', () =>
    import ('./components/admin/Vip/groups/show.vue'));
Vue.component('edit-admin-group', () =>
    import ('./components/admin/Vip/groups/edit.vue'));
//contact
Vue.component('add-admin-contacts', () =>
    import ('./components/admin/Vip/contacts/add.vue'));
Vue.component('show-admin-contacts', () =>
    import ('./components/admin/Vip/contacts/show.vue'));
Vue.component('edit-admin-contact', () =>
    import ('./components/admin/Vip/contacts/edit.vue'));
//category
Vue.component('add-admin-category-market', () =>
    import ('./components/admin/Vip/category/add.vue'));
Vue.component('show-admin-category-markting', () =>
    import ('./components/admin/Vip/category/show.vue'));
Vue.component('edit-admin-category-market', () =>
    import ('./components/admin/Vip/category/edit.vue'));
//amount
Vue.component('show-admin-amount-market', () =>
    import ('./components/admin/Vip/amount/show.vue'));
Vue.component('edit-admin-amount-marketing', () =>
    import ('./components/admin/Vip/amount/edit.vue'));
//send-email 
Vue.component('show-admin-send-email', () =>
    import ('./components/admin/Vip/send/email/show.vue'));
Vue.component('show-admin-group-hi-email', () =>
    import ('./components/admin/Vip/send/email/group_hi.vue'));
Vue.component('show-admin-group-user-email', () =>
    import ('./components/admin/Vip/send/email/group_user.vue'));
Vue.component('show-admin-into-user-send', () =>
    import ('./components/admin/Vip/send/email/into_user.vue'));
//send-sms 
Vue.component('show-admin-send-sms', () =>
    import ('./components/admin/Vip/send/sms/show.vue'));
Vue.component('show-admin-group-hi-sms', () =>
    import ('./components/admin/Vip/send/sms/group_hi.vue'));
Vue.component('show-admin-group-user-sms', () =>
    import ('./components/admin/Vip/send/sms/group_user.vue'));
Vue.component('show-admin-into-user-send-sms', () =>
    import ('./components/admin/Vip/send/sms/into_user.vue'));

//**********************************************************eduComponent*******************************************
Vue.component('edu-register', () =>
    import ('./components/edu/register.vue'));
Vue.component('payment-edu', () =>
    import ('./components/edu/payment.vue'));
Vue.component('edu-site-course', () =>
    import ('./components/edu/show.vue'));
//**********************************************************Admin-EduComponent*******************************************

Vue.component('edu-show-user', () =>
    import ('./components/admin/edu/show_user'));
Vue.component('edu-add-course', () =>
    import ('./components/admin/edu/add_course.vue'));
Vue.component('edu-show-course', () =>
    import ('./components/admin/edu/show_course.vue'));
Vue.component('edit-admin-course', () =>
    import ('./components/admin/edu/edit_course.vue'));
Vue.component('register-admin-course', () =>
    import ('./components/admin/edu/register.vue'));
//**********************************************************Admin-PiComponent*******************************************
Vue.component('pi-show-inquiry', () =>
    import ('./components/admin/pi/transport/show_inquiry.vue'));
Vue.component('pi-answer-inquiry', () =>
    import ('./components/admin/pi/transport/answer_inquiry.vue'));
Vue.component('pi-buy-transport', () =>
    import ('./components/admin/pi/transport/buy_transport.vue'));
Vue.component('add-state', () =>
    import ('./components/admin/pi/state_city/add_state.vue'));
Vue.component('add-city', () =>
    import ('./components/admin/pi/state_city/add_city.vue'));
//**********************************************************profileComponent*******************************************
Vue.component('Pagination', () =>
    import ('vue-pagination-2'));
Vue.component('profile-component', () =>
    import ('./components/profile/ProfileComponent.vue'));
Vue.component('category-product-component', () =>
    import ('./components/profile/categoryProductComponent.vue'));


const app = new Vue({
    el: '#app',
    components: {
        'InfiniteLoading': () =>
            import ('vue-infinite-loading'),
        'Pagination': () =>
            import ('vue-pagination-2'),
        'Loading': () =>
            import ('vue-loading-overlay'),
        'apexchart': () =>
            import ('vue-apexcharts'),

    },
    data: {
        pageConnect: 1,
        totalPageConnect: 0,
        parPageConnect: '',
        optionConnect: {
            chunk: 5
        },
        pageHistory: 1,
        totalPageHistory: 0,
        parPageHistory: '',
        optionHistory: {
            chunk: 5
        },
        FullName: '',
        Phone: '',
        testUp: '',
        captcha: '',
        Email: '',
        Rules: '',
        news: '',
        password: '',
        ImageProfile: '',
        searchBox: '',
        code_email: '',
        inputGetSingleProduct: '',
        code_mobile: '',
        save_code_email: '',
        save_code_mobile: '',
        lang: '',
        inputGetUser: '',
        type_user: '',
        allUser: '',
        EmailLogin: '',
        passwordLogin: '',
        EmailForgetPass: '',
        inputCategoryFa: '',
        inputCategoryEn: '',
        inputCategoryAr: '',
        parentCategory: '',
        imageCategory: '',
        imageSpecial1: '',
        imageSpecial2: '',
        imageSpecial3: '',
        CheckSelectCat: '',
        linkSpecial1: '',
        linkSpecial2: '',
        linkSpecial3: '',
        inputSliderFa: '',
        inputSliderEn: '',
        inputSliderAr: '',
        linkSlider: '',
        inputGetSlider: '',
        allCategories: [],
        allShowSlider: [],
        EditRowSlider: '',
        textSlider: '',
        input_Unit: '',
        emailLogAdmin: '',
        passwordLogAdmin: '',
        allCurrencies: [],
        allSliderSwiper: [],
        allgetCategorySwiper: [],
        totalProductSearch: '',
        totalSupplierSearch: '',
        isLoading: false,
        fullPage: true,
        type_search: '',
        swiperCategory: '',
        swiperTitleFa: '',
        swiperTitleEn: '',
        swiperTitleAr: '',
        search_id: '',
        EndAmount: '',
        startAmount: '',
        messageBox: '',
        checkAllContact: '',
        SearchSupplierFilter: '',
        categorySearchFilter: '',
        productSearchFilter: '',
        supplierProductFilter: [],
        Filter_search_history: '',
        resultHistorySearch: [],
        result_searchHistory: [],
        allResultProductSearch: [],
        allResultSupplierSearch: [],
        page: 1,
        list: [],
        rates: [],
        currency: [],
        supplier_product: [],
        category_product: [],
        CategoryProductFilter: [],
        allContactUs: [],
        countRequest: '1000',
        title: window.location.hash,
        homeUrl: '',
        type_search_History: '',
        rememberMe: '',
        activeSearch: '',
        requestNewsEmail: '',
        infiniteId: +new Date(),
        endpoint: 'https://s3.ir-thr-at1.arvanstorage.com/imageshi/',
        status: 'ExportConsulting',
        name: '',
        tel: '',
        email_contact: '',
        title_contact: '',
        des_contact: '',
        captcha_contact: '',

    },
    components: {
        Loading,
        InfiniteLoading
    },
    created() {
        this.getLang();
        this.getCategories();
        this.getShowSlider();
        this.getAll();
        this.getHistorySearch();
        this.getCurrency();
        this.getSliderSwiper();
        this.getCategorySwiper();
        this.getAllUserSite();
        AOS.init();


    },
    watch: {

        searchBox: function() {

            var searchBox = $('.searchInput');
            if ($('#mute').hasClass('is-active')) {
                if (this.searchBox == '') {
                    $('#mute').removeClass('is-active');
                    $('.result').fadeOut(100);
                    searchBox.removeClass('boder_radios_none');
                    $('.formSearch').removeClass('searchNoun');
                    $('.formSearch > div').removeClass('pb-0');
                }
            } else {
                $('#mute').addClass('is-active');
                $('.result').fadeIn(100);
                searchBox.addClass('boder_radios_none');
                $('.formSearch').addClass('searchNoun');
                $('.formSearch > div').addClass('pb-0');

            }
            if (this.searchBox != '') {

                axios.post('/getSearch', {
                    search: this.searchBox,
                }).then(response => {

                    this.totalProductSearch = response.data[0];
                    this.totalSupplierSearch = response.data[1];

                }, response => {

                    swal("خطا", "لطفا دقایقی دیگر مجدادا امتحان بفرمایید و در صورت رفع نشدن مشکل را گزارش دهید", "error")
                })
            }



        },


    },
    methods: {
        add_contact() {

            var reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
            var here = this;
            if (this.status == null || this.status == "") {
                switch (this.lang) {
                    case "en":
                        swal("Attention", "Please select a status", "warning", { button: "Ok" })
                        break;
                    case "fa":
                        swal("توجه", "لطفا یک وضعیت را انتخاب نمایید", "warning", { button: "تایید" })
                        break;
                    case "ar":
                        swal("انتباه", "الرجاء تحديد حالة", "warning", { button: "فهمت" })
                        break;
                    default:
                        swal("Attention", "Please select a status", "warning", { button: "Ok" })
                        break;
                }
            } else if (this.name == null || this.name == "") {
                switch (this.lang) {
                    case "en":
                        swal("Attention", "Please fill in the Name field", "warning", { button: "Ok" })
                        break;
                    case "fa":
                        swal("توجه", "لطفا فیلد نام  و نام خانوادگی را تکمیل نمایید", "warning", { button: "تایید" })
                        break;
                    case "ar":
                        swal("انتباه", "يرجى ملء حقل الاسم", "warning", { button: "فهمت" })
                        break;
                    default:
                        swal("Attention", "Please fill in the Name field", "warning", { button: "Ok" })
                        break;
                }
            } else if (this.tel == null || this.tel == "") {
                switch (this.lang) {
                    case "en":
                        swal("Attention", "Please fill in the mobile number field", "warning", { button: "Ok" })
                        break;
                    case "fa":
                        swal("توجه", "لطفا فیلد شماره تلفن همراه را تکمیل نمایید", "warning", { button: "تایید" })
                        break;
                    case "ar":
                        swal("انتباه", "يرجى ملء خانة رقم الهاتف المحمول", "warning", { button: "فهمت" })
                        break;
                    default:
                        swal("Attention", "Please fill in the mobile number field", "warning", { button: "Ok" })
                        break;
                }
            } else if (/\D/.test(this.tel)) {
                switch (this.lang) {
                    case "en":
                        swal("Attention", "The phone number field should only be a number", "warning", { button: "Ok" })
                        break;
                    case "fa":
                        swal("توجه", "فیلد شماره تلفن فقط باید عدد باشد", "warning", { button: "تایید" })
                        break;
                    case "ar":
                        swal("انتباه", "يجب أن يكون حقل رقم الهاتف رقمًا فقط", "warning", { button: "فهمت" })
                        break;
                    default:
                        swal("Attention", "The phone number field should only be a number", "warning", { button: "Ok" })
                        break;
                }
            } else if (this.email_contact == null || this.email_contact == "") {
                switch (this.lang) {
                    case "en":
                        swal("Attention", "Please fill in the email field", "warning", { button: "Ok" })
                        break;
                    case "fa":
                        swal("توجه", "لطفا فیلد ایمیل را تکمیل نمایید", "warning", { button: "تایید" })
                        break;
                    case "ar":
                        swal("انتباه", "يرجى ملء حقل البريد الإلكتروني", "warning", { button: "فهمت" })
                        break;
                    default:
                        swal("Attention", "Please fill in the email field", "warning", { button: "Ok" })
                        break;
                }
            } else if (reg.test(this.email_contact) == false) {
                switch (this.lang) {
                    case "en":
                        swal("Attention", "The email field template is incorrect", "warning", { button: "Ok" })
                        break;
                    case "fa":
                        swal("توجه", "الگو فیلد ایمیل اشتباه است", "warning", { button: "تایید" })
                        break;
                    case "ar":
                        swal("انتباه", "قالب حقل البريد الإلكتروني غير صحيح", "warning", { button: "فهمت" })
                        break;
                    default:
                        swal("Attention", "The email field template is incorrect", "warning", { button: "Ok" })
                        break;
                }
            } else if (this.title_contact == null || this.title_contact == "") {
                switch (this.lang) {
                    case "en":
                        swal("Attention", "Please fill in the subject field", "warning", { button: "Ok" })
                        break;
                    case "fa":
                        swal("توجه", "لطفا فیلد موضوع را تکمیل نمایید", "warning", { button: "تایید" })
                        break;
                    case "ar":
                        swal("انتباه", "يرجى ملء حقل الموضوع", "warning", { button: "فهمت" })
                        break;
                    default:
                        swal("Attention", "Please fill in the subject field", "warning", { button: "Ok" })
                        break;
                }
            } else if (this.des_contact == null || this.des_contact == "") {
                switch (this.lang) {
                    case "en":
                        swal("Attention", "Please fill in the description field", "warning", { button: "Ok" })
                        break;
                    case "fa":
                        swal("توجه", "لطفا فیلد توضیحات را تکمیل نمایید", "warning", { button: "تایید" })
                        break;
                    case "ar":
                        swal("انتباه", "يرجى ملء حقل الوصف", "warning", { button: "فهمت" })
                        break;
                    default:
                        swal("Attention", "Please fill in the description field", "warning", { button: "Ok" })
                        break;
                }
            } else if (this.captcha_contact == null || this.captcha_contact == "") {
                switch (this.lang) {
                    case "en":
                        swal("Attention", "Please complete the security code field", "warning", { button: "Ok" })
                        break;
                    case "fa":
                        swal("توجه", "لطفا فیلد کد امنیتی را تکمیل نمایید", "warning", { button: "تایید" })
                        break;
                    case "ar":
                        swal("انتباه", "الرجاء إكمال حقل رمز الحماية", "warning", { button: "فهمت" })
                        break;
                    default:
                        swal("Attention", "Please complete the security code field", "warning", { button: "Ok" })
                        break;
                }
            } else {
                axios.post('/captcha', {
                    captcha: this.captcha_contact,
                }).then(response => {
                    if (response.data == 'notOk') {
                        switch (this.lang) {
                            case "en":
                                swal("Attention", "The security code is incorrect", "error", { button: "Ok" }).then(function() {
                                    $('#CaptchaImg img').click()
                                })
                                break;
                            case "fa":
                                swal("توجه", "کد امنیتی صحیح نمی باشد", "error", { button: "تایید" }).then(function() {
                                    $('#CaptchaImg img').click()
                                })
                                break;
                            case "ar":
                                swal("انتباه", "رمز الحماية غير صحيحة", "error", { button: "فهمت" }).then(function() {
                                    $('#CaptchaImg img').click()
                                })
                                break;
                            default:
                                swal("Attention", "The security code is incorrect", "error", { button: "Ok" }).then(function() {
                                    $('#CaptchaImg img').click()
                                })
                                break;
                        }
                    } else {
                        this.isLoading = true;
                        axios.post('/addcontactUs', {
                            status: this.status,
                            name: this.name,
                            tel: this.tel,
                            email: this.email_contact,
                            title: this.title_contact,
                            des: this.des_contact,
                        }).then(response => {
                            this.isLoading = false;
                            switch (this.lang) {
                                case "en":
                                    swal("HiTajer", "Your request has been successfully submitted", "success", { button: "Ok" }).then(function() {
                                        here.name = '';
                                        here.tel = '';
                                        here.email_contact = '';
                                        here.title_contact = '';
                                        here.des_contact = '';
                                        here.captcha_contact = '';
                                        $('#CaptchaImg img').click()
                                    })
                                    break;
                                case "fa":
                                    swal("هایتاجر", "درخواست شما با موفقیت ثبت گردید", "success", { button: "تایید" }).then(function() {
                                        here.name = '';
                                        here.tel = '';
                                        here.email_contact = '';
                                        here.title_contact = '';
                                        here.des_contact = '';
                                        here.captcha_contact = '';
                                        $('#CaptchaImg img').click()
                                    })

                                    break;
                                case "ar":
                                    swal("هایتاجر", "قد تم تسجيل طلبك بنجاح", "success", { button: "فهمت" }).then(function() {
                                        here.name = '';
                                        here.tel = '';
                                        here.email_contact = '';
                                        here.title_contact = '';
                                        here.des_contact = '';
                                        here.captcha_contact = '';
                                        $('#CaptchaImg img').click()
                                    })

                                    break;
                                default:
                                    swal("HiTajer", "Your request has been successfully submitted", "success", { button: "Ok" }).then(function() {
                                        here.name = '';
                                        here.tel = '';
                                        here.email_contact = '';
                                        here.title_contact = '';
                                        here.des_contact = '';
                                        here.captcha_contact = '';
                                        $('#CaptchaImg img').click()
                                    })
                                    break;
                            }
                        }, response => {

                            swal("خطا", "لطفا دقایقی دیگر مجدادا امتحان بفرمایید و در صورت رفع نشدن مشکل را گزارش دهید", "error")
                        })
                    }
                }, response => {

                    swal("خطا", "لطفا دقایقی دیگر مجدادا امتحان بفرمایید و در صورت رفع نشدن مشکل را گزارش دهید", "error")
                })
            }
        },
        toggleIcone() {
            $('#menuIcon').toggleClass('rot-icon');
        },
        chaildComment(id) {
            document.querySelector('#comment').scrollIntoView({
                behavior: 'smooth'
            });
            $('#alert_answer').show();
            $('#id_parent').val(id);

        },
        closeChildComment() {
            $('#alert_answer').hide();
            $('#id_parent').val('');

        },
        top() {
            $("html, body").animate({ scrollTop: 0 }, "slow");
        },
        NewsAccept() {
            this.isLoading = true;
            var here = this;
            axios.get('/' + localeSite + '/requestNews/' + this.requestNewsEmail).then(response => {
                this.isLoading = false;
                if (response.data == 'success') {
                    switch (this.lang) {
                        case "en":
                            swal("HiTajer", "Your request for news has been successfully registered", "success", { button: "Ok" }).then(function() {
                                here.requestNewsEmail = '';
                            });
                            break;
                        case "fa":
                            swal("هایتاجر", "درخواست شما برای دریافت خبرها با موفقیت ثبت گردید", "success", { button: "تایید" }).then(function() {
                                here.requestNewsEmail = '';
                            });

                            break;
                        case "ar":
                            swal("هایتاجر", "تم تسجيل طلبك للأخبار بنجاح", "success", { button: "فهمت" }).then(function() {
                                here.requestNewsEmail = '';
                            });

                            break;
                        default:
                            swal("HiTajer", "Your request for news has been successfully registered", "success", { button: "Ok" }).then(function() {
                                here.requestNewsEmail = '';
                            });
                            break;
                    }
                } else {
                    switch (this.lang) {
                        case "en":
                            swal("Error", "To receive news, first become a member of the site", "error", { button: "Ok" }).then(function() {
                                here.requestNewsEmail = '';
                            });
                            break;
                        case "fa":
                            swal("خطا", "برای دریافت خبرها ابتدا عضو سایت شوید", "error", { button: "تایید" }).then(function() {
                                here.requestNewsEmail = '';
                            });

                            break;
                        case "ar":
                            swal("خطأ", "يلتلقي الأخبار ، كن أولاً عضوًا في الموقعة", "error", { button: "فهمت" }).then(function() {
                                here.requestNewsEmail = '';
                            });
                            break;
                        default:
                            swal("Error", "To receive news, first become a member of the site", "error", { button: "Ok" }).then(function() {
                                here.requestNewsEmail = '';
                            });
                            break;
                    }
                }

            }, response => {
                this.isLoading = false;
            })
        },
        addViewBanner(bannerId, bannerType, bannerLink, view) {
            this.isLoading = true;
            axios.post('/addViewBanner', {
                type: bannerType,
                id: bannerId,
                view: view,

            }).then(response => {
                this.isLoading = false;
                location.href = bannerLink;

            }, response => {
                this.isLoading = false;
            })
        },
        sendMessageProfile(userId, productId) {

            if (this.messageBox != '') {
                $('.close').click();
                this.isLoading = true;
                axios.post('/sendmessage', {
                    message: this.messageBox,
                    user_id: userId,
                    user_product_id: productId,
                }).then(response => {
                    this.isLoading = false;
                    switch (this.lang) {
                        case "en":
                            swal("HiTajer", "Your message was sent successfully", "success", { button: "Ok" })
                            break;
                        case "fa":
                            swal("هایتاجر", "پیام شما با موفقیت ارسال گردید", "success", { button: "تایید" })

                            break;
                        case "ar":
                            swal("هایتاجر", "لقد تم ارسال رسالتك بنجاح", "success", { button: "فهمت" })

                            break;
                        default:
                            swal("HiTajer", "Your message was sent successfully", "success", { button: "Ok" })
                            break;
                    }
                }, response => {

                    this.isLoading = false;
                    switch (this.lang) {
                        case "en":
                            swal("Error", "Please try again in a few minutes and report if the problem persists", "error", { button: "Ok" })
                            break;
                        case "fa":
                            swal("خطا", "لطفا دقایقی دیگر مجدادا امتحان بفرمایید و در صورت رفع نشدن مشکل گزارش دهید", "error", { button: "تایید" })

                            break;
                        case "ar":
                            swal("خطأ", "يرجى المحاولة مرة أخرى في غضون بضع دقائق والإبلاغ إذا استمرت المشكلة", "error", { button: "فهمت" })
                            break;
                        default:
                            swal("Error", "Please try again in a few minutes and report if the problem persists", "error", { button: "Ok" })
                            break;
                    }
                })
                this.messageBox = '';
            }
        },
        prvCount: function() {
            this.countRequest = parseInt(this.countRequest) - 1
        },
        nextCount: function() {
            this.countRequest = parseInt(this.countRequest) + 1
        },
        sendInquiry: function(to_user, product_id, mobile, prefix, name, meta_id) {
            $('.close').click();
            this.isLoading = true;
            axios.post('/setInquiry', {
                to_user: to_user,
                product_id: product_id,
                name: name,
                mobile: mobile,
                meta_id: meta_id,
                prefix: prefix,
                count: this.countRequest,
            }).then(response => {

                this.isLoading = false;
                switch (this.lang) {
                    case "en":
                        swal("HiTajer", "Inquiry sent successfully", "success", { button: "Ok" })
                        break;
                    case "fa":
                        swal("هایتاجر", "استعلام با موفقیت ارسال گردید", "success", { button: "تایید" })

                        break;
                    case "ar":
                        swal("هایتاجر", "أرسل الاستفسار بنجاح", "success", { button: "فهمت" })

                        break;
                    default:
                        swal("HiTajer", "Inquiry sent successfully", "success", { button: "Ok" })
                        break;
                }

            }, response => {

                this.isLoading = false;
                switch (this.lang) {
                    case "en":
                        swal("Error", "Please try again in a few minutes and report if the problem persists", "error", { button: "Ok" })
                        break;
                    case "fa":
                        swal("خطا", "لطفا دقایقی دیگر مجدادا امتحان بفرمایید و در صورت رفع نشدن مشکل گزارش دهید", "error", { button: "تایید" })

                        break;
                    case "ar":
                        swal("خطأ", "يرجى المحاولة مرة أخرى في غضون بضع دقائق والإبلاغ إذا استمرت المشكلة", "error", { button: "فهمت" })
                        break;
                    default:
                        swal("Error", "Please try again in a few minutes and report if the problem persists", "error", { button: "Ok" })
                        break;
                }
            })
        },

        FilterSearch() {
            this.activeSearch = 'filter';
            this.page = 1;
            this.infiniteId += 1;
        },
        infiniteSearchHandler: function($state) {
            var thisAll = this;
            var id = $('#search_id').val();
            var search = $('#search_text').val();
            var type = $('#search_Type').val();

            if (search == '') {
                search = 'Other';
            }
            if (this.activeSearch == 'filter') {
                if (this.page == 1) {
                    this.allResultProductSearch = [];
                    this.allResultSupplierSearch = [];
                }
                axios.post('/filterAdvance', {
                    productName: this.productSearchFilter,
                    supplier: this.supplierProductFilter,
                    categoryname: this.categorySearchFilter,
                    category: this.CategoryProductFilter,
                    startAmount: this.startAmount,
                    EndAmount: this.EndAmount,
                    page: this.page,
                    search: search,
                    id: id,
                    type: type,
                }).then(response => {
                    return response;
                }).then(data => {

                    if (data.data[1] == 'allFilter') {

                        if (data.data[0].data.length != 0) {
                            $.each(data.data[0].data, function(key, value) {
                                thisAll.allResultProductSearch.push(value);
                            });
                            $state.loaded();
                        } else {
                            $state.complete();
                        }
                    } else {
                        this.rates = data.data[2];
                        this.currency = data.data[4];
                        if (data.data[5].length != 0) {
                            this.supplier_product.push(data.data[5]);

                        }
                        if (data.data[6].length != 0) {
                            this.category_product.push(data.data[6]);
                        }
                        if (data.data[3] == 'Other') {
                            if (data.data[0].data.length != 0 || data.data[1].data.length != 0) {
                                if (data.data[0].data.length != 0) {
                                    $.each(data.data[0].data, function(key, value) {
                                        thisAll.allResultProductSearch.push(value);
                                    });
                                    $state.loaded();
                                }
                                if (data.data[1].data.length != 0) {
                                    $.each(data.data[1].data, function(key, value) {
                                        thisAll.allResultSupplierSearch.push(value);
                                    });
                                    $state.loaded();
                                }
                            } else {
                                $state.complete();
                            }
                        } else if (data.data[3] == 'product') {
                            if (data.data[0].data.length != 0) {
                                $.each(data.data[0].data, function(key, value) {
                                    thisAll.allResultProductSearch.push(value);
                                });
                                $state.loaded();
                            } else {
                                $state.complete();
                            }
                        } else if (data.data[3] == 'supplier') {
                            if (data.data[1].data.length != 0) {
                                $.each(data.data[1].data, function(key, value) {
                                    thisAll.allResultSupplierSearch.push(value);
                                });
                                $state.loaded();
                            } else {
                                $state.complete();
                            }
                        } else {
                            $state.complete();
                        }
                    }


                })

            } else {
                axios.get('/resultSearch/' + search + '/' + id + '/' + type + '/?page=' + this.page).then(response => {
                    return response;
                }).then(data => {
                    this.rates = data.data[2];
                    this.currency = data.data[4];
                    if (data.data[5].length != 0) {
                        this.supplier_product.push(data.data[5]);

                    }
                    if (data.data[6].length != 0) {
                        this.category_product.push(data.data[6]);
                    }
                    if (data.data[3] == 'Other') {
                        if (data.data[0].data.length != 0 || data.data[1].data.length != 0) {
                            if (data.data[0].data.length != 0) {
                                $.each(data.data[0].data, function(key, value) {
                                    thisAll.allResultProductSearch.push(value);
                                });
                                $state.loaded();
                            }
                            if (data.data[1].data.length != 0) {
                                $.each(data.data[1].data, function(key, value) {
                                    thisAll.allResultSupplierSearch.push(value);
                                });
                                $state.loaded();
                            }
                        } else {
                            $state.complete();
                        }
                    } else if (data.data[3] == 'product') {
                        if (data.data[0].data.length != 0) {
                            $.each(data.data[0].data, function(key, value) {
                                thisAll.allResultProductSearch.push(value);
                            });
                            $state.loaded();
                        } else {
                            $state.complete();
                        }
                    } else if (data.data[3] == 'supplier') {
                        if (data.data[1].data.length != 0) {
                            $.each(data.data[1].data, function(key, value) {
                                thisAll.allResultSupplierSearch.push(value);
                            });
                            $state.loaded();
                        } else {
                            $state.complete();
                        }
                    } else {
                        $state.complete();
                    }
                });
            }
            this.page = this.page + 1

        },
        getHistorySearch: function() {

            axios.get('/' + localeSite + '/getHistorySearch/', {}).then(response => {

                this.result_searchHistory = response.data

            }, response => {
                console.log('error');
            })
        },
        showhidee: function() {
            $('#showhide').hide();
            $('#inhide').show();
        },
        hideAll: function() {
            $('#inhide').hide();
        },
        setRate: function(id, event) {
            var rate = event.target.attributes.tag.value;
            $('#findandhide span').removeClass('rateed');
            for (var index = 0; index < rate; index++) {
                document.getElementsByClassName('rate')[index].classList.add('rateed');
            }
            axios.get('/' + localeSite + '/setStar/' + id + '/' + rate, {}).then(response => {}, response => {
                console.log('error');

            })
        },
        follow: function(id, event) {
            $(event.target).toggleClass('mlikedheaderr follow_image')
            axios.get('/' + localeSite + '/setFollow/' + id, {}).then(response => {}, response => {
                console.log('error');
            })
        },
        changeIcon(id, event) {
            axios.get('/' + localeSite + '/setFollow/' + id, {}).then(response => {
                if (event.target.classList.contains('bxs-user-x')) {
                    event.target.classList.remove('bxs-user-x');
                    event.target.classList.add('bxs-user-check');
                    event.target.classList.add('color_o');
                } else if (event.target.classList.contains('bxs-user-check')) {
                    event.target.classList.remove('bxs-user-check');
                    event.target.classList.remove('color_o');
                    event.target.classList.add('bxs-user-x');
                }
            }, response => {
                console.log('error');
            })
        },
        addFavorite: function(id, lng, event) {
            $(event.target).toggleClass('fa-heart fa-heart-o color_o')
            axios.get('/' + localeSite + '/addFavorite/' + id + '/' + lng, {}).then(response => {}, response => {
                console.log('error');
            })
        },
        addView: function(id) {
            axios.get('/' + localeSite + '/addView/' + id, {}).then(response => {}, response => {
                console.log('error');
            })
        },
        getCurrency: function() {
            axios.get('/' + localeSite + '/getCurrency', {}).then(response => {
                this.allCurrencies = response.data
            }, response => {
                console.log('error');
            })
        },
        openAdvanceSearch: function() {
            $('#sidebar_mobile2').fadeIn(200);
            document.getElementById("slide-search").style.width = "250px";
            document.body.style.backgroundColor = "rgba(0,0,0,0.4)";
            document.getElementById("nav").style.backgroundColor = "rgba(0,0,0,0.4)";
            document.getElementById("main").style.opacity = ".2";
            document.getElementById("footer").style.opacity = ".4";
        },
        closeAdvanceSearch: function() {
            $('#sidebar_mobile2').fadeOut(10);
            document.getElementById("slide-search").style.width = "0";
            document.getElementById("nav").style.backgroundColor = "white";
            document.body.style.backgroundColor = "white";
            document.getElementById("main").style.opacity = "1";
            document.getElementById("footer").style.opacity = "1";
        },
        openSearch: function() {
            $('#search2').fadeToggle(300);
        },

        /*Start For the Login page  */
        submitAdminLogin: function() {
            var reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
            if (this.passwordLogAdmin == '') {
                swal("توجه", "لطفا فیلد پسورد را کامل نمایید", "error", { button: "تایید" })
            } else if (this.emailLogAdmin == '') {
                swal("توجه", "لطفا فیلد ایمیل را کامل نمایید", "error", { button: "تایید" })
            } else if (reg.test(this.emailLogAdmin) == false) {
                swal("توجه", "الگو فیلد ایمیل اشتباه است", "error", { button: "تایید" }).then(function() {
                    this.emailLogAdmin = '';
                })
            } else {
                axios.post('/adminCheck', {
                    email: this.emailLogAdmin,
                }).then(response => {
                    if (response.data == 'ok') {
                        axios.post('/user/login', {
                            password: this.passwordLogAdmin,
                            email: this.emailLogAdmin,
                        }).then(response => {
                            axios.get('/user/admin/LogEnter', {}).then(response => {
                                if (response.data == 'ok') {
                                    location.href = '/user/admin';
                                } else {
                                    swal("توجه", "اطلاعات ورود شما با هم مطابقت ندارد", "warning", { button: "تایید" })
                                }

                            }, response => {
                                console.log('error');
                            })

                        }, response => {
                            swal("توجه", "اطلاعات ورود شما با هم مطابقت ندارد", "warning", { button: "تایید" })
                        })
                    } else {
                        swal("توجه", "اطلاعات ورود شما با هم مطابقت ندارد", "warning", { button: "تایید" })
                    }
                }, response => {
                    swal("توجه", "اطلاعات ورود شما با هم مطابقت ندارد", "warning", { button: "تایید" })
                })
            }

        },
        LoginAccount: function() {
            var reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
            if (this.passwordLogin == '') {
                switch (this.lang) {
                    case "en":
                        swal("Attention", "Please complete the password field", "error", { button: "Ok" })
                        break;
                    case "fa":
                        swal("توجه", "لطفا فیلد پسورد را کامل نمایید", "error", { button: "تایید" })
                        break;
                    case "ar":
                        swal("انتباه", "الرجاء إكمال حقل كلمة المرور", "error", { button: "فهمت" })
                        break;
                    default:
                        swal("Attention", "Please complete the password field", "error", { button: "Ok" })
                        break;
                }
                return false;
            } else if (this.EmailLogin == '') {
                switch (this.lang) {
                    case "en":
                        swal("Attention", "Please complete the email field", "error", { button: "Ok" })
                        break;
                    case "fa":
                        swal("توجه", "لطفا فیلد ایمیل را کامل نمایید", "error", { button: "تایید" })
                        break;
                    case "ar":
                        swal("انتباه", "يرجى إكمال حقل البريد الإلكتروني", "error", { button: "فهمت" })
                        break;
                    default:
                        swal("Attention", "Please complete the email field", "error", { button: "Ok" })
                        break;
                }
                return false;
            } else if (reg.test(this.EmailLogin) == false) {
                switch (this.lang) {
                    case "en":
                        swal("Attention", "The email field template is incorrect", "error", { button: "Ok" }).then(function() {
                            this.EmailLogin = '';
                        })
                        break;
                    case "fa":
                        swal("توجه", "الگو فیلد ایمیل اشتباه است", "error", { button: "تایید" }).then(function() {
                            this.EmailLogin = '';
                        })
                        break;
                    case "ar":
                        swal("انتباه", "قالب حقل البريد الإلكتروني غير صحيح", "error", { button: "فهمت" }).then(function() {
                            this.EmailLogin = '';
                        })
                        break;
                    default:
                        swal("Attention", "The email field template is incorrect", "error", { button: "Ok" }).then(function() {
                            this.EmailLogin = '';
                        })
                        break;
                }
                return false;
            } else {
                var url_back = window.location.pathname;
                axios.post('/userCheck', {
                    email: this.EmailLogin,
                }).then(response => {
                    if (response.data == 'ok') {
                        axios.post('/user/login', {
                            password: this.passwordLogin,
                            email: this.EmailLogin,
                            remember: this.rememberMe,
                        }).then(response => {
                            window.location.href = url_back;
                        }, response => {
                            switch (this.lang) {
                                case "en":
                                    swal("Attention", 'Your login information does not match', "warning", { button: "Ok" })
                                    break;
                                case "fa":
                                    swal("توجه", "اطلاعات ورود شما با هم مطابقت ندارد", "warning", { button: "تایید" })
                                    break;
                                case "ar":
                                    swal("انتباه", 'معلومات تسجيل الدخول الخاصة بك لا تتطابق', "warning", { button: "فهمت" })
                                    break;
                                default:
                                    swal("Attention", 'Your login information does not match', "warning", { button: "Ok" })
                                    break;
                            }
                        })
                    } else {
                        switch (this.lang) {
                            case "en":
                                swal("Attention", 'Your login information does not match', "warning", { button: "Ok" })
                                break;
                            case "fa":
                                swal("توجه", "اطلاعات ورود شما با هم مطابقت ندارد", "warning", { button: "تایید" })
                                break;
                            case "ar":
                                swal("انتباه", 'معلومات تسجيل الدخول الخاصة بك لا تتطابق', "warning", { button: "فهمت" })
                                break;
                            default:
                                swal("Attention", 'Your login information does not match', "warning", { button: "Ok" })
                                break;
                        }
                    }
                }, response => {
                    switch (this.lang) {
                        case "en":
                            swal("Attention", 'Your login information does not match', "warning", { button: "Ok" })
                            break;
                        case "fa":
                            swal("توجه", "اطلاعات ورود شما با هم مطابقت ندارد", "warning", { button: "تایید" })
                            break;
                        case "ar":
                            swal("انتباه", 'معلومات تسجيل الدخول الخاصة بك لا تتطابق', "warning", { button: "فهمت" })
                            break;
                        default:
                            swal("Attention", 'Your login information does not match', "warning", { button: "Ok" })
                            break;
                    }
                })
            }

        },
        FilterInput: function(data) {

            if (this.inputGetUser.length == 0 || this.inputGetUser == 0) return true;

            if (data.name != null && data.name.match(this.inputGetUser)) {
                return this.inputGetUser;
            }

        },
        FilterType: function(data) {

            if (this.type_user.length == 0 || this.type_user == 0) return true;

            if (data.type != null && data.type == this.type_user) {
                return this.type_user;
            } else if (this.type_user == 'notCheck') {
                if (data.admin_check == null) {
                    return this.type_user;
                }
            }

        },
        ForgetPass: function() {
            var EmailForget = this.EmailForgetPass;
            var reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
            if (EmailForget == null || EmailForget == "" || reg.test(EmailForget) == false) {
                switch (this.lang) {
                    case "en":
                        swal("Attention", "Invalid email address", "warning", { button: "Ok" }, )
                        break;
                    case "fa":
                        swal("توجه", "آدرس ایمیل وارد شده نامعتبر است", "warning", { button: "تایید" })
                        break;
                    case "ar":
                        swal("انتباه", "عنوان البريد الإلكتروني غير صالح", "warning", { button: "فهمت" })
                        break;
                    default:
                        swal("Attention", "Invalid email address", "warning", { button: "Ok" }, )
                        break;
                }
            } else {
                this.isLoading = true;

                axios.post('/ForgetPasswordSend', {
                    email: EmailForget,
                }).then(response => {
                    this.isLoading = false;

                    if (response.data == 'ok') {

                        this.EmailLogin = this.EmailForgetPass;
                        switch (this.lang) {
                            case "en":
                                swal("mission accomplished", "We have sent you a new password", "success", { button: "Ok" }).then(() => {
                                    $('#login').click();
                                })
                                break;
                            case "fa":
                                swal("عملیات با موفقیت انجام شد", "پسورد جدید برای شما ارسال کردید", "success", { button: "تایید" }).then(() => {
                                    $('#login').click();
                                })
                                break;
                            case "ar":
                                swal("تمت المهمة", "رمز الحماية غير صحيحة", "success", { button: "فهمت" }).then(() => {
                                    $('#login').click();
                                })
                                break;
                            default:
                                swal("mission accomplished", "We have sent you a new password", "success", { button: "Ok" }).then(() => {
                                    $('#login').click();
                                })
                                break;
                        }

                    } else if (response.data == 'notAccount') {
                        switch (this.lang) {
                            case "en":
                                swal("Attention", 'The entered email address does not have an account on the site', "warning", { button: "Ok" })
                                break;
                            case "fa":
                                swal("توجه", "ادرس ایمیل وارد شده حساب کابری در سایت ندارد", "warning", { button: "تایید" })
                                break;
                            case "ar":
                                swal("انتباه", 'عنوان البريد الإلكتروني الذي تم إدخاله ليس لديه حساب على الموقع', "warning", { button: "فهمت" })
                                break;
                            default:
                                swal("Attention", 'The entered email address does not have an account on the site', "warning", { button: "Ok" })
                                break;
                        }
                    }

                }, response => {

                    this.isLoading = false;
                    switch (this.lang) {
                        case "en":
                            swal("Error", "Please try again in a few minutes and report if the problem persists", "error", { button: "Ok" })
                            break;
                        case "fa":
                            swal("خطا", "لطفا دقایقی دیگر مجدادا امتحان بفرمایید و در صورت رفع نشدن مشکل گزارش دهید", "error", { button: "تایید" })

                            break;
                        case "ar":
                            swal("خطأ", "يرجى المحاولة مرة أخرى في غضون بضع دقائق والإبلاغ إذا استمرت المشكلة", "error", { button: "فهمت" })
                            break;
                        default:
                            swal("Error", "Please try again in a few minutes and report if the problem persists", "error", { button: "Ok" })
                            break;
                    }
                })
            }

        },
        /*End For the Login page  */
        /*Start For the register page  */

        EnglishType: function(event) {
            var lang = this.lang;
            var arregex = /^[a-zA-Z0-9_ ]*$/;
            if (!arregex.test(event.key)) {
                event.preventDefault();
                switch (lang) {
                    case "en":
                        swal("Attention", "The first and last name fields must be entered in English", "warning", { button: "Ok" })
                        break;
                    case "fa":
                        swal("توجه", "فیلد نام و نام خانوادگی باید انگلیسی وارد شود ", "warning", { button: "تایید" })
                        break;
                    case "ar":
                        swal("انتباه", "يجب إدخال حقلي الاسم الأول والأخير باللغة الإنجليزية", "warning", { button: "فهمت" })
                        break;
                    default:
                        swal("Attention", "The first and last name fields must be entered in English", "warning", { button: "Ok" })
                        break;
                }

            }
        },
        isNumber: function(evt) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            var target = evt.target ? evt.target : evt.srcElement;
            if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
                evt.preventDefault();;
            } else if (charCode == 46) {
                evt.preventDefault();;

            } else if (target.value.length == 0 && charCode == 48) {

                evt.preventDefault();;

            } else {

                return true;
            }
        },
        onlyNumber($event) {
            //console.log($event.keyCode); //keyCodes value
            let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
            if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // 46 is dot
                $event.preventDefault();
            } else if (keyCode == 46) {
                $event.preventDefault();

            } else {
                var lang = this.lang;
                $('#phoneNumber').on('keyup', function() {
                    var number = $('#phoneNumber').val();
                    var one = number.toString()[0];
                    if (one == 0) {
                        switch (lang) {
                            case "en":
                                swal("Attention", "Enter your phone number without zero", "warning", { button: "Ok" })
                                break;
                            case "fa":
                                swal("توجه", "شماره تلفن خود را بدون صفر وارد کنید", "warning", { button: "تایید" })
                                break;
                            case "ar":
                                swal("انتباه", "أدخل رقم هاتفك بدون صفر", "warning", { button: "فهمت" })
                                break;
                            default:
                                swal("Attention", "Enter your phone number without zero", "warning", { button: "Ok" })
                                break;
                        }
                        $('#phoneNumber').val("");
                    }
                    var two = number.toString()[1];
                    var prefix = $('#ContRegister').val();
                    if (two == 8 && prefix == '98') {
                        switch (lang) {
                            case "en":
                                swal("Attention", "Enter the mobile number field according to the template", "warning", { button: "Ok" })
                                break;
                            case "fa":
                                swal("توجه", "فیلد شماره تلفن همراه را مطابق الگو وارد نمایید", "warning", { button: "تایید" })
                                break;
                            case "ar":
                                swal("انتباه", "أدخل حقل رقم الهاتف المحمول وفقًا للقالب", "warning", { button: "فهمت" })
                                break;
                            default:
                                swal("Attention", "Enter the mobile number field according to the template", "warning", { button: "Ok" })
                                break;
                        }
                        $('#phoneNumber').val("");
                    }
                });
            }
        },
        ZeroType: function() {

        },
        getLang: function() {
            axios.get('/' + localeSite + '/getLang', {}).then(response => {
                this.lang = response.data
            }, response => {
                console.log('error');
            })
        },
        AddAccount: function() {
            if (this.code_mobile != this.save_code_mobile) {
                switch (this.lang) {
                    case "en":
                        swal("Attention", "The code entered is incorrect", "error", { button: "Ok" })
                        break;
                    case "fa":
                        swal("توجه", "کد وارد شده اشتباه می باشد", "error", { button: "تایید" })
                        break;
                    case "ar":
                        swal("انتباه", "الكود الذي تم إدخاله غير صحيح", "error", { button: "فهمت" })
                        break;
                    default:
                        swal("Attention", "The code entered is incorrect", "error", { button: "Ok" })
                        break;
                }
                return false;
            } else if (this.code_mobile == this.save_code_mobile) {
                var prefix = $('#ContRegister').val();
                var country_name = $('#country_name').val();

                axios.post('/AddAccount', {
                    name: this.FullName,
                    mobile: this.Phone,
                    password: this.password,
                    email: this.Email,
                    news: this.news,
                    prefix: prefix,
                    country_name: country_name,
                }).then(response => {
                    if (response.data == 'ok') {
                        axios.post('/user/login', {
                            password: this.password,
                            email: this.Email,
                        }).then(response => {
                            location.href = '/' + localeSite + '/profile';
                        }, response => {
                            switch (this.lang) {
                                case "en":
                                    swal("Attention", 'Your login information does not match', "warning", { button: "Ok" })
                                    break;
                                case "fa":
                                    swal("توجه", "اطلاعات ورود شما با هم مطابقت ندارد", "warning", { button: "تایید" })
                                    break;
                                case "ar":
                                    swal("انتباه", 'معلومات تسجيل الدخول الخاصة بك لا تتطابق', "warning", { button: "فهمت" })
                                    break;
                                default:
                                    swal("Attention", 'Your login information does not match', "warning", { button: "Ok" })
                                    break;
                            }
                        })
                    }
                }, response => {

                    this.isLoading = false;
                    switch (this.lang) {
                        case "en":
                            swal("Error", "Please try again in a few minutes and report if the problem persists", "error", { button: "Ok" })
                            break;
                        case "fa":
                            swal("خطا", "لطفا دقایقی دیگر مجدادا امتحان بفرمایید و در صورت رفع نشدن مشکل گزارش دهید", "error", { button: "تایید" })

                            break;
                        case "ar":
                            swal("خطأ", "يرجى المحاولة مرة أخرى في غضون بضع دقائق والإبلاغ إذا استمرت المشكلة", "error", { button: "فهمت" })
                            break;
                        default:
                            swal("Error", "Please try again in a few minutes and report if the problem persists", "error", { button: "Ok" })
                            break;
                    }
                })
            }

        },
        openCat: function() {
            $('#dropdown0 .drop_cat').fadeToggle(0);
        },
        registerValidate: function() {
            var FullName = this.FullName;
            var Phone = this.Phone;
            Phone = +Phone;
            var captcha = this.captcha;
            var Rules = this.Rules;
            var password = this.password;
            var prefix = $('#ContRegister').val();
            if (prefix != "98") {
                prefix = "00" + prefix;
            } else {
                prefix = prefix;
            }
            var reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
            var validatePhone = /^\d+$/;
            var Email = this.Email;
            if (FullName == null || FullName == "" || password == null || password == "" || captcha == null || captcha == "" || Phone == null || validatePhone.test(Phone) == false || Phone == "" || Email == null || Email == "" || Rules == false || reg.test(Email) == false) {

                if (FullName == null || FullName == "") {
                    switch (this.lang) {
                        case "en":
                            swal("Attention", "The first and last name fields should not be empty", "warning", { button: "Ok" })
                            break;
                        case "fa":
                            swal("توجه", "فیلد نام و نام خانوادگی نباید خالی باشد", "warning", { button: "تایید" })
                            break;
                        case "ar":
                            swal("انتباه", "يجب ألا يكون حقلا الاسم الأول والأخير فارغين", "warning", { button: "فهمت" })
                            break;
                        default:
                            swal("Attention", "The first and last name fields should not be empty", "warning", { button: "Ok" })
                            break;
                    }
                } else if (password == null || password == "") {
                    switch (this.lang) {
                        case "en":
                            swal("Attention", "The password field should not be empty", "warning", { button: "Ok" })
                            break;
                        case "fa":
                            swal("توجه", "فیلد رمز عبور نباید خالی باشد", "warning", { button: "تایید" })
                            break;
                        case "ar":
                            swal("انتباه", "يجب ألا يكون حقل كلمة المرور فارغًا", "warning", { button: "فهمت" })
                            break;
                        default:
                            swal("Attention", "The password field should not be empty", "warning", { button: "Ok" })
                            break;
                    }
                } else if (Phone == null || Phone == "") {
                    switch (this.lang) {
                        case "en":
                            swal("Attention", "The mobile number field should not be empty", "warning", { button: "Ok" })
                            break;
                        case "fa":
                            swal("توجه", "فیلد شماره تلفن همراه نباید خالی باشد", "warning", { button: "تایید" })
                            break;
                        case "ar":
                            swal("انتباه", "يجب ألا يكون حقل رقم الهاتف المحمول فارغًا", "warning", { button: "فهمت" })
                            break;
                        default:
                            swal("Attention", "The mobile number field should not be empty", "warning", { button: "Ok" })
                            break;
                    }
                } else if (validatePhone.test(Phone) == false) {
                    switch (this.lang) {
                        case "en":
                            swal("Attention", "Enter the mobile number field according to the template", "warning", { button: "Ok" })
                            break;
                        case "fa":
                            swal("توجه", "فیلد شماره تلفن همراه را مطابق الگو وارد نمایید", "warning", { button: "تایید" })
                            break;
                        case "ar":
                            swal("انتباه", "أدخل حقل رقم الهاتف المحمول وفقًا للقالب", "warning", { button: "فهمت" })
                            break;
                        default:
                            swal("Attention", "Enter the mobile number field according to the template", "warning", { button: "Ok" })
                            break;
                    }
                } else if (Email == null || Email == "" || reg.test(Email) == false) {
                    switch (this.lang) {
                        case "en":
                            swal("Attention", "Invalid email address", "warning", { button: "Ok" }, )
                            break;
                        case "fa":
                            swal("توجه", "آدرس ایمیل وارد شده نامعتبر است", "warning", { button: "تایید" })
                            break;
                        case "ar":
                            swal("انتباه", "عنوان البريد الإلكتروني غير صالح", "warning", { button: "فهمت" })
                            break;
                        default:
                            swal("Attention", "Invalid email address", "warning", { button: "Ok" }, )
                            break;
                    }

                } else if (Rules == false) {
                    switch (this.lang) {
                        case "en":
                            swal("Attention", "First, read and approve the terms and conditions", "warning", { button: "Ok" })
                            break;
                        case "fa":
                            swal("توجه", "ابتدا شرایط و قوانین را مطالعه و تایید بفرمایید", "warning", { button: "تایید" })
                            break;
                        case "ar":
                            swal("انتباه", "أولاً ، اقرأ ووافق على الشروط والأحكام", "warning", { button: "فهمت" })
                            break;
                        default:
                            swal("Attention", "First, read and approve the terms and conditions", "warning", { button: "Ok" })
                            break;
                    }

                } else if (captcha == null || captcha == "") {
                    switch (this.lang) {
                        case "en":
                            swal("Attention", "The security code field should not be empty", "warning", { button: "Ok" })
                            break;
                        case "fa":
                            swal("توجه", "فیلد کد امنیتی نباید خالی باشد", "warning", { button: "تایید" })
                            break;
                        case "ar":
                            swal("انتباه", "يجب ألا يكون حقل رمز الحماية فارغًا", "warning", { button: "فهمت" })
                            break;
                        default:
                            swal("Attention", "The security code field should not be empty", "warning", { button: "Ok" })
                            break;
                    }
                }

            } else {
                axios.post('/captcha', {
                    captcha: captcha,
                }).then(response => {
                    if (response.data == 'notOk') {
                        switch (this.lang) {
                            case "en":
                                swal("Attention", "The security code is incorrect", "error", { button: "Ok" }).then(function() {
                                    $('#captcha img').click()
                                })
                                break;
                            case "fa":
                                swal("توجه", "کد امنیتی صحیح نمی باشد", "error", { button: "تایید" }).then(function() {
                                    $('#captcha img').click()
                                })
                                break;
                            case "ar":
                                swal("انتباه", "رمز الحماية غير صحيحة", "error", { button: "فهمت" }).then(function() {
                                    $('#captcha img').click()
                                })
                                break;
                            default:
                                swal("Attention", "The security code is incorrect", "error", { button: "Ok" }).then(function() {
                                    $('#captcha img').click()
                                })
                                break;
                        }
                    } else {
                        var code_email = 10000 + Math.floor(Math.random() * (99999 - 10000));
                        var code_mobile = 10000 + Math.floor(Math.random() * (99999 - 10000));
                        this.save_code_email = code_email;
                        this.save_code_mobile = code_mobile
                        var lang = this.lang;
                        var phone = this.Phone;
                        phone = +phone;
                        var email = this.Email;
                        axios.post('/CheckAccount', {
                            mobile: phone,
                            email: email,
                            prefix: prefix,
                        }).then(response => {
                            if (response.data == 'mobile') {
                                switch (lang) {
                                    case "en":
                                        swal("Attention", "Mobile number is already registered", "error", { button: "Ok" }).then(function() {
                                            $('#captcha img').click()
                                            $('#login').click();
                                        })
                                        break;
                                    case "fa":
                                        swal("توجه", "شماره موبایل قبلا ثبت کردیده است", "error", { button: "تایید" }).then(function() {
                                            $('#captcha img').click()
                                            $('#login').click();
                                        })
                                        break;
                                    case "ar":
                                        swal("انتباه", "رقم الهاتف الجوال مسجل بالفعل", "error", { button: "فهمت" }).then(function() {
                                            $('#captcha img').click()
                                            $('#login').click();
                                        })
                                        break;
                                    default:
                                        swal("Attention", "Your mobile number and email are already registered", "error", { button: "Ok" }).then(function() {
                                            $('#captcha img').click()
                                            $('#login').click();
                                        })
                                        break;
                                }
                            } else if (response.data == 'email') {
                                switch (lang) {
                                    case "en":
                                        swal("Attention", "Your email has already been registered", "error", { button: "Ok" }).then(function() {
                                            $('#captcha img').click()
                                            $('#login').click();
                                        })
                                        break;
                                    case "fa":
                                        swal("توجه", "ایمیل شما قبلا ثبت کردیده است", "error", { button: "تایید" }).then(function() {
                                            $('#captcha img').click()
                                            $('#login').click();
                                        })
                                        break;
                                    case "ar":
                                        swal("انتباه", "تم تسجيل بريدك الإلكتروني بالفعل", "error", { button: "فهمت" }).then(function() {
                                            $('#captcha img').click()
                                            $('#login').click();
                                        })
                                        break;
                                    default:
                                        swal("Attention", "Your email has already been registered", "error", { button: "Ok" }).then(function() {
                                            $('#captcha img').click()
                                            $('#login').click();
                                        })
                                        break;
                                }
                            } else if (response.data == 'Registered') {
                                switch (lang) {
                                    case "en":
                                        swal("Attention", "Your mobile number and email are already registered", "error", { button: "Ok" }).then(function() {
                                            $('#captcha img').click()
                                            $('#login').click();
                                        })
                                        break;
                                    case "fa":
                                        swal("توجه", "شماره موبایل و ایمیل شما قبلا ثبت کردیده است", "error", { button: "تایید" }).then(function() {
                                            $('#captcha img').click()
                                            $('#login').click();
                                        })
                                        break;
                                    case "ar":
                                        swal("انتباه", "رقم هاتفك المحمول والبريد الإلكتروني مسجلان بالفعل", "error", { button: "فهمت" }).then(function() {
                                            $('#captcha img').click()
                                            $('#login').click();
                                        })
                                        break;
                                    default:
                                        swal("Attention", "Your mobile number and email are already registered", "error", { button: "Ok" }).then(function() {
                                            $('#captcha img').click()
                                            $('#login').click();
                                        })
                                        break;
                                }
                            } else if (response.data == 'ok') {
                                switch (lang) {
                                    case "en":
                                        swal("Welcome to the HiTajer", "Email confirmation link and verification code sent to you", "success", { button: "Ok" }).then(function() {
                                            $('#disable-mobile').val(Phone);
                                            $('#RegisterForm').hide();
                                            $('#codeRegister').show();
                                            axios.post('/SendMessage', {
                                                code_email: code_email,
                                                code_mobile: code_mobile,
                                                mobile: prefix + Phone,
                                                template: 'loginen',
                                                email: Email,
                                                subject: 'کد تایید',
                                            }).then(response => {

                                            }, response => {
                                                switch (this.lang) {
                                                    case "en":
                                                        swal("Error", "Please try again in a few minutes and report if the problem persists", "error", { button: "Ok" })
                                                        break;
                                                    case "fa":
                                                        swal("خطا", "لطفا دقایقی دیگر مجدادا امتحان بفرمایید و در صورت رفع نشدن مشکل گزارش دهید", "error", { button: "تایید" })

                                                        break;
                                                    case "ar":
                                                        swal("خطأ", "يرجى المحاولة مرة أخرى في غضون بضع دقائق والإبلاغ إذا استمرت المشكلة", "error", { button: "فهمت" })
                                                        break;
                                                    default:
                                                        swal("Error", "Please try again in a few minutes and report if the problem persists", "error", { button: "Ok" })
                                                        break;
                                                }
                                            })
                                        })
                                        break;
                                    case "fa":
                                        swal("به هایتاجر خوش آمدید", "لینک تایید ایمیل و کد تایید برای شما ارسال گردید", "success", { button: "تایید" }).then(function() {
                                            $('#disable-mobile').val(Phone);
                                            $('#RegisterForm').hide();
                                            $('#codeRegister').show();
                                            axios.post('/SendMessage', {
                                                code_email: code_email,
                                                code_mobile: code_mobile,
                                                mobile: prefix + Phone,
                                                template: 'loginfa',
                                                email: Email,
                                                subject: 'کد تایید',
                                            }).then(response => {

                                            }, response => {
                                                switch (this.lang) {
                                                    case "en":
                                                        swal("Error", "Please try again in a few minutes and report if the problem persists", "error", { button: "Ok" })
                                                        break;
                                                    case "fa":
                                                        swal("خطا", "لطفا دقایقی دیگر مجدادا امتحان بفرمایید و در صورت رفع نشدن مشکل گزارش دهید", "error", { button: "تایید" })

                                                        break;
                                                    case "ar":
                                                        swal("خطأ", "يرجى المحاولة مرة أخرى في غضون بضع دقائق والإبلاغ إذا استمرت المشكلة", "error", { button: "فهمت" })
                                                        break;
                                                    default:
                                                        swal("Error", "Please try again in a few minutes and report if the problem persists", "error", { button: "Ok" })
                                                        break;
                                                }
                                            })
                                        })
                                        break;
                                    case "ar":
                                        swal("مرحبا بكم في رجل الأعمال", "تم إرسال رابط التأكيد عبر البريد الإلكتروني ورمز التحقق إليك", "success", { button: "فهمت" }).then(function() {
                                            $('#disable-mobile').val(Phone);
                                            $('#RegisterForm').hide();
                                            $('#codeRegister').show();
                                            axios.post('/SendMessage', {
                                                code_email: code_email,
                                                code_mobile: code_mobile,
                                                mobile: prefix + Phone,
                                                template: 'loginar',
                                                email: Email,
                                                subject: 'کد تایید',
                                            }).then(response => {

                                            }, response => {
                                                switch (this.lang) {
                                                    case "en":
                                                        swal("Error", "Please try again in a few minutes and report if the problem persists", "error", { button: "Ok" })
                                                        break;
                                                    case "fa":
                                                        swal("خطا", "لطفا دقایقی دیگر مجدادا امتحان بفرمایید و در صورت رفع نشدن مشکل گزارش دهید", "error", { button: "تایید" })

                                                        break;
                                                    case "ar":
                                                        swal("خطأ", "يرجى المحاولة مرة أخرى في غضون بضع دقائق والإبلاغ إذا استمرت المشكلة", "error", { button: "فهمت" })
                                                        break;
                                                    default:
                                                        swal("Error", "Please try again in a few minutes and report if the problem persists", "error", { button: "Ok" })
                                                        break;
                                                }
                                            })
                                        })
                                        break;
                                    default:
                                        swal("Welcome to the HiTajer", "Email confirmation link and verification code sent to you", "success", { button: "Ok" }).then(function() {
                                            $('#disable-mobile').val(Phone);
                                            $('#RegisterForm').hide();
                                            $('#codeRegister').show();
                                            axios.post('/SendMessage', {
                                                code_email: code_email,
                                                code_mobile: code_mobile,
                                                mobile: prefix + Phone,
                                                template: 'loginen',
                                                email: Email,
                                                subject: 'کد تایید',
                                            }).then(response => {

                                            }, response => {
                                                switch (this.lang) {
                                                    case "en":
                                                        swal("Error", "Please try again in a few minutes and report if the problem persists", "error", { button: "Ok" })
                                                        break;
                                                    case "fa":
                                                        swal("خطا", "لطفا دقایقی دیگر مجدادا امتحان بفرمایید و در صورت رفع نشدن مشکل گزارش دهید", "error", { button: "تایید" })

                                                        break;
                                                    case "ar":
                                                        swal("خطأ", "يرجى المحاولة مرة أخرى في غضون بضع دقائق والإبلاغ إذا استمرت المشكلة", "error", { button: "فهمت" })
                                                        break;
                                                    default:
                                                        swal("Error", "Please try again in a few minutes and report if the problem persists", "error", { button: "Ok" })
                                                        break;
                                                }
                                            })
                                        })
                                        break;
                                }
                            }
                        }, response => {

                            swal("خطا", "لطفا دقایقی دیگر مجدادا امتحان بفرمایید و در صورت رفع نشدن مشکل را گزارش دهید", "error")
                        })
                    }
                }, response => {

                    swal("خطا", "لطفا دقایقی دیگر مجدادا امتحان بفرمایید و در صورت رفع نشدن مشکل را گزارش دهید", "error")
                })
            }


        },

        backRegister() {
            $('#captcha img').click()
            $('#RegisterForm').show();
            $('#codeRegister').hide();
        },
        /*End For the register page  */
        /*Start For side drop-down menus in Mobile View  */
        openNavCat: function() {
            $('#ul-slide-category').fadeIn(1000)
            document.getElementById("slide-category").style.width = "250px";
            document.body.style.backgroundColor = "rgba(0,0,0,0.4)";
            document.getElementById("nav").style.backgroundColor = "rgba(0,0,0,0.4)";
            document.getElementById("main").style.opacity = ".2";
            document.getElementById("footer").style.opacity = ".4";
        },
        openNavProfile: function() {
            $('#ul-slide-profile').fadeIn(1000)
            document.getElementById("slide-profile").style.width = "250px";
            document.body.style.backgroundColor = "rgba(0,0,0,0.4)";
            document.getElementById("nav").style.backgroundColor = "rgba(0,0,0,0.4)";
            document.getElementById("main").style.opacity = ".2";
            document.getElementById("footer").style.opacity = ".4";
        },
        closeNavCat: function() {
            $('#ul-slide-category').fadeOut(10)
            document.getElementById("slide-category").style.width = "0";
            document.getElementById("nav").style.backgroundColor = "white";
            document.body.style.backgroundColor = "white";
            document.getElementById("main").style.opacity = "1";
            document.getElementById("footer").style.opacity = "1";
        },
        closeNavProfile: function() {
            $('#ul-slide-profile').fadeOut(10)
            document.getElementById("slide-profile").style.width = "0";
            document.getElementById("nav").style.backgroundColor = "white";
            document.body.style.backgroundColor = "white";
            document.getElementById("main").style.opacity = "1";
            document.getElementById("footer").style.opacity = "1";
        },
        /*End For side drop-down menus in Mobile View  */
        /**************************Start For Admin  View ****************************/
        AddCurrency: function() {
            if (this.input_Unit == '') {
                swal("توجه", "لطفا قیمت ارز را وارد کنید", "error", { button: "تایید" })
            } else {
                var currency_code = $('#addCurrency #country_name').val();
                axios.post('/user/admin/setCurrency', {
                    price: this.input_Unit,
                    currency_code: currency_code,
                }).then(response => {
                    this.input_Unit = '';
                    swal("ارز جدید با موفقیت اضافه گردید", { button: "تایید" });
                }, response => {
                    swal("خطا", "لطفا دقایقی دیگر مجدادا امتحان بفرمایید و در صورت رفع نشدن مشکل را گزارش دهید", "error")
                })
            }

        },
        addSpecialSupplier: function(id, name) {
            axios.get('/user/admin/addSpecialSupplier/' + id + '/' + name).then(response => {
                this.getAll();
                swal("کاربر به لیست عرضه کنندگان ویژه اضافه گردید")
            }, response => {
                console.log('error');
            })
        },
        removeSpecialSupplier: function(id, name) {
            axios.get('/user/admin/removeSpecialSupplier/' + id + '/' + name).then(response => {
                this.getAll();
                swal("کاربر از لیست عرضه کنندگان ویژه حذف گردید")
            }, response => {

                console.log('error');
            })
        },

        getAllUserSite: function() {
            var location = window.location.pathname;
            var lastPart = location.split('/')[3];
            if (location.split('/')[2] == 'profile') {
                this.homeUrl = 'profile';
            } else {
                this.homeUrl = 'home';
            }

        },
        getAll: function() {
            var location = window.location.pathname;
            var lastPart = location.split('/')[3];
            if (lastPart == 'showUsers' || lastPart == 'registerSupplier' || lastPart == 'specialSupplier' || lastPart == 'showUsersAdmin') {
                this.isLoading = true;
                axios.get('/user/admin/getShowUsers').then(response => {
                    this.allUser = response.data;
                    this.isLoading = false
                }, response => {
                    this.isLoading = false;
                    console.log('error');
                })
            }
        },

        ZeroTypeAdmin: function(event) {
            var number = event.target.value;
            var one = number.toString()[0];
            if (one == 0) {
                swal("توجه", "شماره تلفن خود را بدون صفر وارد کنید", "warning", { button: "تایید" }).then(function() {
                    event.target.value = '';
                })

            }
            var two = number.toString()[1];
            var prefix = $('#ContRegister').val();
            if (two == 8 && prefix == '98') {
                swal("توجه", "فیلد شماره تلفن همراه را مطابق الگو وارد نمایید", "warning", { button: "تایید" }).then(function() {
                    event.target.value = '';
                })
            }

        },
        previewFiles: function(event) {
            var here = this;
            var file = event.target.files[0];
            this.ImageProfile = event.target.files[0];
            var FileSize = file.size; // in MB
            if (FileSize > 500000) {

                swal("توجه", "حجم فایل دریافتی نباید بیشتر از 500kb باشد", "error", { button: "تایید" }).then(function() {
                    here.ImageProfile = '';
                    event.target.value = '';
                })
            } else {
                var ext = event.target.value.match(/\.([^\.]+)$/)[1];
                switch (ext) {
                    case 'jpg':
                    case 'jpeg':
                    case 'png':
                        break;
                    default:
                        swal("توجه", "پسوند فایل شما باید png یا jpg باشد", "error", { button: "تایید" }).then(function() {
                            here.ImageProfile = '';
                            event.target.value = '';
                        })

                }
            }
        },
        AddUnit: function() {
            if (this.input_Unit == '') {
                switch (this.lang) {
                    case "en":
                        swal("Attention", "Please enter the unit name", "error", { button: "Ok" })
                        break;
                    case "fa":
                        swal("توجه", "لطفا نام واحد را وارد کنید", "error", { button: "تایید" })
                        break;
                    case "ar":
                        swal("انتباه", "الرجاء إدخال اسم الوحدة", "error", { button: "فهمت" })
                        break;
                    default:
                        swal("Attention", "Please enter the unit name", "error", { button: "Ok" })
                        break;
                }
                return false;
            } else {
                axios.post('/user/admin/setUnit', {
                    name: this.input_Unit,
                }).then(response => {
                    this.input_Unit = '';
                    swal("واحد جدید با موفقیت اضافه گردید", { button: "تایید" });
                }, response => {

                    swal("خطا", "لطفا دقایقی دیگر مجدادا امتحان بفرمایید و در صورت رفع نشدن مشکل را گزارش دهید", "error")
                })
            }

        },
        DeleteSlider: function(id, image, name) {

            axios.post('/user/admin/DestroySlider', {
                id: id,
                image: image,
                name: name,
            }).then(response => {
                this.getShowSlider();
                swal("اسلایدر با موفقیت حذف گردیدند")
            }, response => {

                swal("خطا", "لطفا دقایقی دیگر مجدادا امتحان بفرمایید و در صورت رفع نشدن مشکل را گزارش دهید", "error")
            })


        },
        backEdit: function() {
            this.EditRowSlider = '';
            this.textSlider = '';
            this.linkSlider = '';
            this.imageCategory = '';
            this.getShowSlider();
            $('.AddCat').find('input:file').val('');
            $('#detailSlider').hide();
            $('#sliderList').show();
        },
        getEditSlider: function(id) {
            this.EditRowSlider = '';
            this.textSlider = '';
            this.linkSlider = '';
            axios.get('/user/admin/editSlider/' + id).then(response => {
                this.EditRowSlider = response.data;
                this.textSlider = response.data.title;
                this.linkSlider = response.data.link;
                $('#sliderList').hide();
                $('#detailSlider').show();
            }, response => {

                console.log('error');
            })
        },
        SetEditSlider: function(id, image, name) {
            if (this.textSlider == '') {
                swal("توجه", "لطفا فیلد نام اسلایدر را وارد نمایید", "error", { button: "تایید" })
            } else if (this.linkSlider == '') {
                swal("توجه", "لطفا فیلد لینک اسلایدر را وارد نمایید", "error", { button: "تایید" })
            } else {
                let formData = new FormData();
                formData.append('image', this.imageCategory);
                formData.append('title', this.textSlider);
                formData.append('link', this.linkSlider);
                formData.append('oldImage', image);
                formData.append('id', id);
                formData.append('name', name);
                axios.post('/user/admin/setEditSlider', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }).then(response => {
                    this.imageCategory = '';
                    this.getEditSlider(id);
                    swal("عکس با موفقیت ویرایش گردید", { button: "تایید" });
                }, response => {

                    swal("خطا", "لطفا دقایقی دیگر مجدادا امتحان بفرمایید و در صورت رفع نشدن مشکل را گزارش دهید", "error")
                })
            }


        },
        getShowSlider: function() {
            var location = window.location.pathname;
            var lastPart = location.split('/')[3];
            if (lastPart == 'showSlider') {
                this.isLoading = true;
                axios.get('/user/admin/getShowSlider').then(response => {
                    this.allShowSlider = response.data;
                    this.isLoading = false
                }, response => {
                    this.isLoading = false;
                    console.log('error');
                })
            }

        },
        AddSlider: function() {
            var here = this;
            if (this.inputSliderFa == '') {
                swal("توجه", "لطفا فیلد نام اسلایدر به فارسی را وارد نمایید", "error", { button: "تایید" })
            } else if (this.inputSliderEn == '') {
                swal("توجه", "لطفا فیلد نام اسلایدر به انگلیسی را وارد نمایید", "error", { button: "تایید" })
            } else if (this.inputSliderAr == '') {
                swal("توجه", "لطفا فیلد نام اسلایدر به عربی را وارد نمایید", "error", { button: "تایید" })
            } else if (this.linkSlider == '') {
                swal("توجه", "لطفا فیلد لینک اسلایدر را وارد نمایید", "error", { button: "تایید" })
            } else if (this.imageCategory == '') {
                swal("توجه", "لطفا تصویر را انتخاب نمایید", "error", { button: "تایید" })
            } else {
                this.isLoading = true;

                let formData = new FormData();
                formData.append('image', this.imageCategory);
                formData.append('titleFa', this.inputSliderFa);
                formData.append('titleEn', this.inputSliderEn);
                formData.append('titleAr', this.inputSliderAr);
                formData.append('link', this.linkSlider);
                axios.post('/user/admin/addSlider', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }).then(response => {
                    this.isLoading = false;
                    swal("عکس جدید با موفقیت اضافه گردید", { button: "تایید" }).then(function() {
                        $('.AddCat div input').val('');
                        here.inputSliderFa = "";
                        here.inputSliderEn = "";
                        here.inputSliderAr = "";
                        here.linkSlider = "";
                        here.imageCategory = "";

                    });;
                }, response => {
                    this.isLoading = false;
                    swal("خطا", "لطفا دقایقی دیگر مجدادا امتحان بفرمایید و در صورت رفع نشدن مشکل را گزارش دهید", "error")
                })
            }

        },
        previewFilesCat: function(event) {
            var here = this;
            var file = event.target.files[0];
            this.imageCategory = event.target.files[0];
            var FileSize = file.size; // in MB
            if (FileSize > 500000) {

                swal("توجه", "حجم فایل دریافتی نباید بیشتر از 500kb باشد", "error").then(function() {
                    $('.AddCat').find('input:file').val('');
                    here.imageCategory = '';
                })

            } else {
                var ext = $('.AddCat').find('input:file').val().match(/\.([^\.]+)$/)[1];
                switch (ext) {
                    case 'jpg':
                    case 'jpeg':
                    case 'png':
                        break;
                    default:
                        swal("توجه", "پسوند فایل شما باید png یا jpg باشد", "error").then(function() {
                            $('.AddCat').find('input:file').val('');
                            here.imageCategory = '';
                        })

                }
            }
        },
        previewFilesCatSpecial: function(event) {
            var here = this;
            var file = event.target.files[0];
            if (event.target.id == 'special1') {
                this.imageSpecial1 = event.target.files[0];
            } else if (event.target.id == 'special2') {
                this.imageSpecial2 = event.target.files[0];
            } else if (event.target.id == 'special3') {
                this.imageSpecial3 = event.target.files[0];
            }

            var FileSize = file.size; // in MB
            if (FileSize > 500000) {

                swal("توجه", "حجم فایل دریافتی نباید بیشتر از 500kb باشد", "error").then(function() {
                    if (event.target.id == 'special1') {
                        here.imageSpecial1 = '';
                    } else if (event.target.id == 'special2') {
                        here.imageSpecial2 = '';
                    } else if (event.target.id == 'special3') {
                        here.imageSpecial3 = '';
                    }
                    event.target.value = '';
                })

            } else {
                var ext = event.target.value.match(/\.([^\.]+)$/)[1];
                switch (ext) {
                    case 'jpg':
                    case 'jpeg':
                    case 'png':
                        break;
                    default:
                        swal("توجه", "پسوند فایل شما باید png یا jpg باشد", "error").then(function() {
                            if (event.target.id == 'special1') {
                                here.imageSpecial1 = '';
                            } else if (event.target.id == 'special2') {
                                here.imageSpecial2 = '';
                            } else if (event.target.id == 'special3') {
                                here.imageSpecial3 = '';
                            }
                            event.target.value = '';
                        })
                }
            }
        },
        AddCategorySpecial: function() {
            if (this.linkSpecial1 == '') {
                swal("توجه", "لطفا دسته بندی تصویر اول را انتخاب نمایید", "error", { button: "تایید" })
            } else if (this.linkSpecial2 == '') {
                swal("توجه", "لطفا دسته بندی تصویر دوم را وارد نمایید", "error", { button: "تایید" })
            } else if (this.linkSpecial3 == '') {
                swal("توجه", "لطفا دسته بندی تصویر سوم را وارد نمایید", "error", { button: "تایید" })
            } else if (this.imageSpecial1 == '') {
                swal("توجه", "لطفا تصویر اول را انتخاب نمایید", "error", { button: "تایید" })
            } else if (this.imageSpecial2 == '') {
                swal("توجه", "لطفا  تصویر دوم را انتخاب نمایید", "error", { button: "تایید" })
            } else if (this.imageSpecial3 == '') {
                swal("توجه", "لطفا تصویر سوم را انتخاب نمایید", "error", { button: "تایید" })
            } else {
                let formData = new FormData();
                formData.append('link1', this.linkSpecial1);
                formData.append('link2', this.linkSpecial2);
                formData.append('link3', this.linkSpecial3);
                formData.append('image1', this.imageSpecial1);
                formData.append('image2', this.imageSpecial2);
                formData.append('image3', this.imageSpecial3);
                axios.post('/user/admin/addCategorySpecial', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }).then(response => {
                    $('.AddCat div input:file').val('');
                    this.linkSpecial1 = '';
                    this.linkSpecial2 = '';
                    this.linkSpecial3 = '';
                    this.imageSpecial1 = '';
                    this.imageSpecial2 = '';
                    this.imageSpecial3 = '';
                    swal("عملیات با موفقیت انجام شد", { button: "تایید" });
                }, response => {

                    swal("خطا", "لطفا دقایقی دیگر مجدادا امتحان بفرمایید و در صورت رفع نشدن مشکل را گزارش دهید", "error")
                })
            }


        },
        AddCategory: function() {
            if (this.parentCategory == '') {
                swal("توجه", "لطفا والد دسته جدید را انتخاب نمایید", "error", { button: "تایید" })
            } else if (this.inputCategoryFa == '') {
                swal("توجه", "لطفا فیلد نام دسته بندی به فارسی را وارد نمایید", "error", { button: "تایید" })
            } else if (this.inputCategoryEn == '') {
                swal("توجه", "لطفا فیلد نام دسته بندی به انگلیسی را وارد نمایید", "error", { button: "تایید" })
            } else if (this.inputCategoryAr == '') {
                swal("توجه", "لطفا فیلد نام دسته بندی به عربی را وارد نمایید", "error", { button: "تایید" })
            } else if (this.imageCategory == '') {
                swal("توجه", "لطفا تصویر دسته جدید را انتخاب نمایید", "error", { button: "تایید" })
            } else {
                $('.AddCat div input').val('');
                let formData = new FormData();
                formData.append('image', this.imageCategory);
                formData.append('nameFa', this.inputCategoryFa);
                formData.append('nameEn', this.inputCategoryEn);
                formData.append('nameAr', this.inputCategoryAr);
                formData.append('parent', this.parentCategory);
                formData.append('special', this.CheckSelectCat);
                axios.post('/user/admin/addCategory', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }).then(response => {
                    if (response.data == 'hasProduct') {
                        swal("خطا", "والد دسته بندی دارای محصول می باشد ، ابتدا محصولات والد دسته بندی را حذف و سپس  زیر دسته را اضافه نمایید", "error")
                    } else {
                        $('.AddCat div input').val('');
                        this.inputCategoryFa = "";
                        this.inputCategoryEn = "";
                        this.inputCategoryAr = "";
                        swal("دسته بندی جدید با موفقیت اضافه گردید", { button: "تایید" });
                        this.getCategories();
                    }

                }, response => {

                    swal("خطا", "لطفا دقایقی دیگر مجدادا امتحان بفرمایید و در صورت رفع نشدن مشکل را گزارش دهید", "error")
                })
            }

        },
        EnglishTypeCat: function(event) {
            var here = this;
            var arregex = /^[a-zA-Z0-9_ ]*$/;
            if (!arregex.test(event.key)) {
                swal("توجه", "لطفا فیلد را انگلیسی تکمیل نمایید", "error", { button: "تایید" }).then(function() {
                    event.target.value = '';
                    here.inputSliderEn = '';
                    here.inputCategoryEn = '';
                })


            }
        },
        getCategories: function() {
            var location = window.location.pathname;
            var lastPart = location.split('/')[3];
            if (lastPart == 'category' || lastPart == 'ViewAddSwiper' || lastPart == 'spacialCategory') {
                axios.get('/user/admin/getCategory').then(response => {
                    this.allCategories = response.data;
                }, response => {

                    console.log('error');
                })
            }

        },
        FilterSlider: function(data) {

            if (this.inputGetSlider.length == 0 || this.inputGetSlider == 0) return true;

            if (data.title != null && data.title.match(this.inputGetSlider)) {
                return this.inputGetSlider;
            }

        },
        select: function() {
            var checkId = $('table tbody tr input:checkbox').click();
        },
        AddSwiper: function() {
            if (this.swiperCategory == '' || this.swiperCategory == null) {
                swal("توجه", "لطفا دسته بندی را انتخاب نمایید", "error", { button: "تایید" })
            } else if (this.swiperTitleFa == '' || this.swiperTitleFa == null) {
                swal("توجه", "لطفا عنوان فارسی را وارد نمایید", "error", { button: "تایید" })
            } else if (this.swiperTitleEn == '' || this.swiperTitleEn == null) {
                swal("توجه", "لطفا عنوان انگلیسی را وارد نمایید", "error", { button: "تایید" })
            } else if (this.swiperTitleAr == '' || this.swiperTitleAr == null) {
                swal("توجه", "لطفا عنوان عربی را وارد نمایید", "error", { button: "تایید" })
            } else {
                this.isLoading = true;
                axios.post('/user/admin/AddSwiper', {
                    swiperTitleFa: this.swiperTitleFa,
                    swiperTitleEn: this.swiperTitleEn,
                    swiperTitleAr: this.swiperTitleAr,
                    category_id: this.swiperCategory,
                }).then(response => {
                    this.isLoading = false;
                    if (response.data == 'full') {
                        swal("توجه", "ظرفیت تکمیل است لطفا ابتدا یک اسلایدر را حذف نمایید", "error", { button: "تایید" })
                    } else {
                        this.swiperTitleFa = '';
                        this.swiperTitleEn = '';
                        this.swiperTitleAr = '';
                        swal("اسلایدر با موفقیت ثبت گردید")
                    }

                }, response => {

                    swal("خطا", "لطفا دقایقی دیگر مجدادا امتحان بفرمایید و در صورت رفع نشدن مشکل را گزارش دهید", "error")
                })
            }


        },
        getSliderSwiper: function() {
            var location = window.location.pathname;
            var lastPart = location.split('/')[3];
            if (lastPart == 'showSwiper') {
                this.isLoading = true;
                axios.get('/user/admin/getshowSwiper').then(response => {
                    this.allSliderSwiper = response.data;
                    this.isLoading = false
                }, response => {
                    this.isLoading = false;
                    console.log('error');
                })
            }

        },
        getCategorySwiper: function() {
            var location = window.location.pathname;
            var lastPart = location.split('/')[3];
            if (lastPart == 'ViewAddSwiper') {
                this.isLoading = true;
                axios.get('/user/admin/getCategorySwiper').then(response => {
                    this.allgetCategorySwiper = response.data;
                    this.isLoading = false
                }, response => {
                    this.isLoading = false;
                    console.log('error');
                })
            }

        },
        Delete: function(id, image, name) {
            this.isLoading = true;
            axios.post('/user/admin/DestroyUser', {
                id: id,
                image: image,
                name: name,
            }).then(response => {
                this.getAll();
                this.isLoading = false
                swal("کاربر با موفقیت حذف گردید")
            }, response => {
                this.isLoading = false
                swal("ابتدا محصولات کاربر را باید حذف نمایید")
            })


        },
        DeleteSwiper: function(id, name) {
            this.isLoading = true;
            axios.post('/user/admin/DestroySliderSwiper', {
                id: id,
                name: name,
            }).then(response => {
                this.getSliderSwiper();
                this.isLoading = false
                swal("اسلایدر با موفقیت حذف گردید")
            }, response => {
                this.isLoading = false
            })


        },
        callbackHistory: function(page) {
            if (this.type_search == 'product') {
                this.isLoading = true;
                axios.get('/user/admin/getHistoryProduct?page=' + page, {}).then(response => {
                    this.resultHistorySearch = response.data.data;
                    this.totalPageHistory = response.data.total;
                    this.parPageHistory = response.data.parPage;
                    this.type_search_History = 'product';
                    this.isLoading = false;
                }, response => {
                    this.isLoading = false;
                    console.log('error');
                })
            } else if (this.type_search == 'supplier') {
                this.isLoading = true;
                axios.get('/user/admin/getHistorySupplier?page=' + page, {}).then(response => {
                    this.resultHistorySearch = response.data.data;
                    this.totalPageHistory = response.data.total;
                    this.parPageHistory = response.data.parPage;
                    this.type_search_History = 'supplier';
                    this.isLoading = false;
                }, response => {
                    this.isLoading = false;
                    console.log('error');
                })
            }
        },
        getSearchHistory: function() {

            if (this.type_search == 'product') {
                this.isLoading = true;
                axios.get('/user/admin/getHistoryProduct', {}).then(response => {
                    this.resultHistorySearch = response.data.data;
                    this.totalPageHistory = response.data.total;
                    this.parPageHistory = response.data.parPage;
                    this.type_search_History = 'product';
                    this.isLoading = false;
                }, response => {
                    this.isLoading = false;
                    console.log('error');
                })
            } else if (this.type_search == 'supplier') {
                this.isLoading = true;
                axios.get('/user/admin/getHistorySupplier', {}).then(response => {
                    this.resultHistorySearch = response.data.data;
                    this.totalPageHistory = response.data.total;
                    this.parPageHistory = response.data.parPage;
                    this.type_search_History = 'supplier';
                    this.isLoading = false;
                }, response => {
                    this.isLoading = false;
                    console.log('error');
                })
            }
        },
        getMatchProducts: function() {

            if (this.inputGetSingleProduct == '') {
                swal("توجه", "لطفا نام محصول را وارد نمایید", "error", { button: "تایید" })
            } else {
                this.isLoading = true;
                axios.post('/user/admin/getShowProductHistory', {
                    search: this.inputGetSingleProduct,
                }).then(response => {
                    this.resultHistorySearch = response.data.data;
                    this.totalPageHistory = response.data.total;
                    this.parPageHistory = response.data.parPage;
                    this.type_search_History = 'product';
                    this.isLoading = false
                }, response => {
                    this.isLoading = false;
                    swal("خطا", "لطفا دقایقی دیگر مجدادا امتحان بفرمایید و در صورت رفع نشدن مشکل را گزارش دهید", "error")

                })
            }

        },
        FilterHistory: function(data) {

            if (this.Filter_search_history.length == 0 || this.Filter_search_history == 0) return true;
            if (data.title != null) {
                if (data.title != null && data.title.match(this.Filter_search_history)) {
                    return this.Filter_search_history;
                }
            } else if (data.store_name != null) {
                if (data.store_name != null && data.store_name.match(this.Filter_search_history)) {
                    return this.Filter_search_history;
                }
            }
        },
        AddSearchHistory: function(type, id) {
            this.isLoading = true;
            axios.post('/user/admin/addHistorySearch', {
                id: id,
                type: type,
            }).then(response => {
                this.isLoading = false
                swal("عملیات با موفقیت انجام گردید")
            }, response => {
                this.isLoading = false
            })
        },
        deleteHistorySearch: function(id, name, type) {
            this.isLoading = true;
            axios.get('/user/admin/deleteHistorySearch/' + id + '/' + name + '/' + type).then(response => {
                this.isLoading = false
                swal("عملیات با موفقیت انجام گردید").then(function() {
                    location.href = '/user/admin/showHistorySearch';
                })
            }, response => {
                this.isLoading = false;
                console.log('error');
            })
        },
        callbackConnect: function(page) {
            var start_date = $('#dtp_input2').val();
            var end_date = $('#dtp_input3').val();
            if (start_date == '' && end_date == '' && this.checkAllContact == '') {
                swal("توجه", "لطفا ابتدا یکی از گزینه ها را انتخاب کنید", "error", { button: "تایید" })
            } else {
                this.isLoading = true;
                axios.post('/user/admin/getContactUs?page=' + page, {
                    end_date: end_date,
                    start_date: start_date,
                    AllContact: this.checkAllContact,
                }).then(response => {
                    this.allContactUs = response.data.data;
                    this.totalPageConnect = response.data.total;
                    this.parPageConnect = response.data.parPage;
                    this.isLoading = false
                }, response => {
                    this.isLoading = false;
                    swal("خطا", "لطفا دقایقی دیگر مجدادا امتحان بفرمایید و در صورت رفع نشدن مشکل را گزارش دهید", "error")

                })
            }
        },
        getAllContactUs: function() {
            var start_date = $('#dtp_input2').val();
            var end_date = $('#dtp_input3').val();
            if (start_date == '' && end_date == '' && this.checkAllContact == '') {
                swal("توجه", "لطفا ابتدا یکی از گزینه ها را انتخاب کنید", "error", { button: "تایید" })
            } else {
                this.isLoading = true;
                axios.post('/user/admin/getContactUs', {
                    end_date: end_date,
                    start_date: start_date,
                    AllContact: this.checkAllContact,
                }).then(response => {
                    this.allContactUs = response.data.data;
                    this.totalPageConnect = response.data.total;
                    this.parPageConnect = response.data.parPage;
                    this.isLoading = false
                }, response => {
                    this.isLoading = false;
                    swal("خطا", "لطفا دقایقی دیگر مجدادا امتحان بفرمایید و در صورت رفع نشدن مشکل را گزارش دهید", "error")

                })
            }

        },







        /****************************End For Admin  View**********************/












    }






});